/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";

const AllFeaturesContent = () => {
  const language = useSelector(selectLanguage);

  return (
    <>
      {language === "en" ? (
        <motion.div
          variants={routeVariants}
          initial="initial"
          animate="final"
          id="content"
          className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
        >
          <div className="container">
            <div className="row">
              <div className="col-sm-8 col-sm-offset-2 text-center">
                <h2 className="font-weight-bold mt-30">
                  Get the most out of GoPaperless
                </h2>
                <p className="mt-25 mb-25">
                  Explore all the features to find out how GoPaperless portal
                  can help your teams sign documents and collect signatures
                  electronically.
                </p>
              </div>
            </div>
          </div>
          <div className="container security-footer">
            <div className="row">
              <div className="col-sm-8 col-sm-offset-2 text-center mbt-40">
                <p>
                  <span className="color-1e90ff">P</span> Professional plan{" "}
                  <strong>|&nbsp;</strong>{" "}
                  <span className="color-1e90ff">B</span> Business plan&nbsp;{" "}
                  <strong>|&nbsp;</strong>{" "}
                  <span className="color-1e90ff">E</span> Enterprise plan
                </p>
              </div>
            </div>
          </div>

          <div className="container description px-md-0">
            <div className="row text-center mb-100">
              <div className="col-md-4">
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="474"
                >
                  A
                </h2>
                <p className="text-left" data-renderer-start-pos="474">
                  <strong>
                    Accountless signing{" "}
                    <span className="color-1e90ff">P | B |&nbsp;E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="474">
                  Allow your customers, partners or other parties you share your
                  documents with to sign or view them without logging in or
                  signing up to GoPaperless portal.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="646">
                  <strong>Address book and contact categories</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="646">
                  Save contacts to an address book to easily find them next time
                  you need to share a document.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="646">
                  <strong>Advanced and Qualified Electronic Signatures</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="777">
                  Sign your documents with secure Advanced and Qualified
                  Electronic Signatures using high-assurance eIDs that meet the
                  strictest requirements set forth under the EU eIDAS
                  regulation.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="1011">
                  <strong>
                    Advanced reporting and analytics{" "}
                    <span className="color-1e90ff">E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1011">
                  Get custom reports on user activity, signed documents, and
                  other statistics.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="1126">
                  <strong>
                    Approvals <span className="color-1e90ff">B | E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1126">
                  Add additional consents to the documents to make sure they are
                  viewed and confirmed by the responsible person before signing.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="1269">
                  <strong>Audit trail</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1269">
                  See all actions performed by the users thr/ough a detailed
                  list of events.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="1357">
                  <strong>Automatic notifications</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1357">
                  Get informed when your signature is needed or when other
                  parties have signed the document.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="1477"
                >
                  B
                </h2>
                <p className="text-left" data-renderer-start-pos="1477">
                  <strong>Batch actions</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1477">
                  Sign, delete or download all selected documents with just one
                  click from a single location.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="1585">
                  <strong>
                    Branded user experience{" "}
                    <span className="color-1e90ff">B | E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1585">
                  Provide branded document signing experience for your customers
                  and business partners.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="1585"
                >
                  C
                </h2>
                <p className="text-left" data-renderer-start-pos="1703">
                  <strong>
                    Centralised billing{" "}
                    <span className="color-1e90ff">B | E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1703">
                  Reduce time spent on paying separate invoices, instead give
                  each team member their own GoPaperless account and pay for
                  everything with a single invoice.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="1879">
                  <strong>Comments</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1879">
                  Discuss important topics and leave notes for other signing
                  parties.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="1879"
                >
                  D
                </h2>
                <p className="text-left" data-renderer-start-pos="1961">
                  <strong>Deadlines</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="1961">
                  Set signing, sealing or approving deadlines to make sure other
                  parties perform needed actions on your documents on time.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="2094">
                  <strong>Document categories</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="2094">
                  Sort documents into categories for a more convenient and
                  orderly experience.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="1879"
                >
                  F
                </h2>
                <p className="text-left" data-renderer-start-pos="1961">
                  <strong>Form templates </strong>
                  <span className="color-1e90ff">
                    <strong>B | E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="1961">
                  Create custom fillable documents – your customers or partners
                  will be able to easily fill them and sign them right on
                  GoPaperless.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="2458"
                >
                  M
                </h2>
                <p className="text-left" data-renderer-start-pos="2461">
                  <strong>Mobile app</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="2461">
                  Get all the awesome portal features on the go plus instant
                  notifications about what’s going on with your documents right
                  to your mobile phone.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="2617">
                  <strong>Multilingual interface</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="2617">
                  Use GoPaperless in English, Vietnamese.
                </p>
                <hr />
                <p data-renderer-start-pos="2617"></p>
              </div>
              <div className="col-md-4">
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="2710"
                >
                  O
                </h2>
                <p className="text-left" data-renderer-start-pos="2713">
                  <strong>
                    On-boarding services <span className="color-1e90ff">E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="2713">
                  Get personal trainings on GoPaperless portal usage and other
                  help needed to start using the portal.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="2835"
                >
                  P
                </h2>
                <p className="text-left" data-renderer-start-pos="2838">
                  <strong>Payment by invoice </strong>
                  <span className="color-1e90ff">
                    <strong>E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="2838">
                  Use GoPaperless services and pay by a received invoice at the
                  end of the month.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="2938">
                  <strong>Permissions based on document categories </strong>
                  <span className="color-1e90ff">
                    <strong>B | E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="2938">
                  Manage user rights to edit, share or delete documents assigned
                  to categories.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="3064">
                  <strong>Portal API </strong>
                  <span className="color-1e90ff">
                    <strong>E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="3064">
                  Integrate API for automating actions in document signing
                  portal right into your information system.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="3180">
                  <strong>Premium SLA </strong>
                  <span className="color-1e90ff">
                    <strong>E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="3180">
                  Get guaranteed services availability 24/7.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="3240"
                >
                  Q
                </h2>
                <p className="text-left" data-renderer-start-pos="3243">
                  <strong>Quick login</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="3243">
                  Login to GoPaperless portal faster as the browser remembers
                  your last login information, so all you need to do is to
                  confirm your identity by entering a preferred eID’s PIN code,
                  without typing personal information each time.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="4507">
                  <strong>Qualified timestamps&nbsp;</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="4507">
                  Secure your documents against forgery and backdating as all
                  signing and sealing transactions in GoPaperless portal include
                  qualified timestamps.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="3479"
                >
                  R
                </h2>
                <p className="text-left" data-renderer-start-pos="3482">
                  <strong>Reminders</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="3482">
                  Send additional reminders to people when their signature or
                  approval is pending, with a click of a button.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="3601"
                >
                  S
                </h2>
                <p className="text-left" data-renderer-start-pos="3604">
                  <strong>Seal hosting </strong>
                  <span className="color-1e90ff">
                    <strong>B | E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="3604">
                  Have your qualified e-seal certificate hosted in our secure
                  HSM. This allows to provide an easy way to e-seal the
                  documents for your users.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="3764">
                  <strong>Sealing</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="3764">
                  Instead of signing documents as a natural person, seal them as
                  a legal person using an electronic seal.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="3878">
                  <strong>Secure sharing</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="3878">
                  Only intended persons who authenticate with an eID matching
                  that person can access documents.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="3989">
                  <strong>Shared address book contacts </strong>
                  <span className="color-1e90ff">
                    <strong>B |&nbsp;E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="3989">
                  Make contacts visible to all the users in your team.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="4086">
                  <strong>Shared document categories </strong>
                  <span className="color-1e90ff">
                    <strong>B | E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="4086">
                  Create shared document categories allowing your team mates to
                  access all the documents within the category.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="4347">
                  <strong>Signing with variety of eIDs</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="4347">
                  Sign documents with your preferred eID solution, whether it’s
                  a national ID card, Mobile ID or other.&nbsp;
                  <a href="javascript:void(0)">See all supported eIDs.</a>
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="4504"
                ></h2>
                <p className="text-left" data-renderer-start-pos="4507"></p>
              </div>
              <div className="col-md-4">
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="4659"
                >
                  U
                </h2>
                <p className="text-left" data-renderer-start-pos="4662">
                  <strong>Usage report </strong>
                  <span className="color-1e90ff">
                    <strong>B | E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="4662">
                  Track usage statistics – the number of documents created,
                  signatures used and times logged into the GoPaperless portal –
                  of your team members separately or combined.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="4844">
                  <strong>User management </strong>
                  <span className="color-1e90ff">
                    <strong>B | E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="4844">
                  Easily manage your team’s accounts and document access rights
                  using centralised controls to make sure sensitive documents
                  stay in the right hands.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="5014">
                  <strong>User roles </strong>
                  <strong>
                    <span className="color-1e90ff">P | B |&nbsp;E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="5014">
                  Apply different roles for users: they have to approve or sign
                  a document, or can only view it.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="5130"
                >
                  V
                </h2>
                <p className="text-left" data-renderer-start-pos="5133">
                  <strong>Validation of signatures and seals</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="5133">
                  Check whether signatures or seals from other parties are valid
                  and legally binding.
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="5254">
                  <strong>Variety of documents formats</strong>
                </p>
                <p className="text-left" data-renderer-start-pos="5254">
                  Sign documents in whatever format you need — from PDF and
                  ASiC-E container to the formats used in the Baltics (BDoc,
                  EDoc and ADoc).
                </p>
                <hr />
                <p className="text-left" data-renderer-start-pos="5418">
                  <strong>VIP support </strong>
                  <strong>
                    <span className="color-1e90ff">E</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="5418">
                  Get all the support you may need thr/oughout the entire
                  GoPaperless usage period.
                </p>
                <hr />
                <h2
                  className="text-left font-weight-bold"
                  data-renderer-start-pos="5512"
                >
                  W
                </h2>
                <p className="text-left" data-renderer-start-pos="5515">
                  <strong>Workflows </strong>
                  <span className="color-1e90ff">
                    <strong>B | E</strong>
                  </span>
                </p>
                <p className="text-left" data-renderer-start-pos="5515">
                  Create a sequence of actions for every signing party to make
                  sure the document signing process is well-rounded and in
                  order.
                </p>
                <hr />
                <p data-renderer-start-pos="5515"></p>
              </div>
            </div>
          </div>
          <Footer />
          <NavbarBottom />
        </motion.div>
      ) : (
        <motion.div
          variants={routeVariants}
          initial="initial"
          animate="final"
          id="content"
          className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
        >
          <div className="container">
            <div className="row">
              <div className="col-sm-8 col-sm-offset-2 text-center">
                <h2 className="font-weight-bold mt-30">
                  Tận dụng tối đa GoPaperless
                </h2>
                <p className="mt-25 mb-25">
                  Khám phá tất cả các tính năng để tìm hiểu cách cổng thông tin
                  GoPaperless có thể giúp nhóm của bạn ký tài liệu và thu thập
                  chữ ký điện tử.
                </p>
              </div>
            </div>
          </div>
          <div className="container security-footer">
            <div className="row">
              <div className="col-sm-8 col-sm-offset-2 text-center mbt-40">
                <p>
                  <span className="color-1e90ff">C</span> Chuyên nghiệp{" "}
                  <strong>|&nbsp;</strong>{" "}
                  <span className="color-1e90ff">K</span> Kinh doanh&nbsp;{" "}
                  <strong>|&nbsp;</strong>{" "}
                  <span className="color-1e90ff">D</span> Doanh nghiệp
                </p>
              </div>
            </div>
          </div>

          <div className="container description px-md-0">
            <div className="row text-center mb-100">
              <div className="col-md-4">
                <h2 className="text-left font-weight-bold">B</h2>

                <p className="text-left">
                  <strong>Báo cáo sử dụng </strong>
                  <span className="color-1e90ff">
                    <strong>K | D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Theo dõi số liệu thống kê sử dụng – số lượng tài liệu được
                  tạo, chữ ký được sử dụng và số lần đăng nhập vào cổng
                  GoPaperless – của các thành viên trong nhóm của bạn một cách
                  riêng biệt hoặc kết hợp.
                </p>
                <hr />

                <p className="text-left">
                  <strong>
                    Báo cáo và phân tích nâng cao{" "}
                    <span className="color-1e90ff">D</span>
                  </strong>
                </p>
                <p className="text-left">
                  Nhận báo cáo tùy chỉnh về hoạt động của người dùng, tài liệu
                  đã ký và các số liệu thống kê khác.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Bình luận</strong>
                </p>
                <p className="text-left">
                  Thảo luận về các chủ đề quan trọng và để lại ghi chú cho các
                  bên ký kết khác.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Biểu mẫu </strong>
                  <span className="color-1e90ff">
                    <strong>K | D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Tạo tài liệu có thể điền tùy chỉnh – khách hàng hoặc đối tác
                  của bạn sẽ có thể dễ dàng điền và ký tên ngay trên
                  GoPaperless.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">C</h2>

                <p className="text-left">
                  <strong>Cổng thông tin API </strong>
                  <span className="color-1e90ff">
                    <strong>D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Tích hợp API để tự động hóa các thao tác trong cổng ký văn bản
                  vào ngay hệ thống thông tin của bạn.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Chia sẻ an toàn </strong>
                </p>
                <p className="text-left">
                  Chỉ những người dự định xác thực bằng eID khớp với người đó
                  mới có thể truy cập tài liệu.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Con dấu lưu trữ </strong>
                  <span className="color-1e90ff">
                    <strong>K | D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Lưu trữ chứng chỉ con dấu điện tử đủ điều kiện của bạn trong
                  HSM an toàn của chúng tôi. Điều này cho phép cung cấp một cách
                  dễ dàng để niêm phong điện tử các tài liệu cho người dùng của
                  bạn.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Chữ ký điện tử nâng cao và đạt tiêu chuẩn</strong>
                </p>
                <p className="text-left">
                  Ký tài liệu của bạn bằng Chữ ký điện tử đủ điều kiện và nâng
                  cao an toàn bằng cách sử dụng eID có độ đảm bảo cao đáp ứng
                  các yêu cầu nghiêm ngặt nhất được quy định theo quy định eIDAS
                  của Việt Nam.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">D</h2>

                <p className="text-left">
                  <strong>Danh mục tài liệu</strong>
                </p>
                <p className="text-left">
                  Sắp xếp tài liệu thành các danh mục để có trải nghiệm thuận
                  tiện và có trật tự hơn.
                </p>
                <hr />

                <p className="text-left">
                  <strong>
                    Dịch vụ quy nạp <span className="color-1e90ff">D</span>
                  </strong>
                </p>
                <p className="text-left" data-renderer-start-pos="2713">
                  Nhận các khóa đào tạo cá nhân về cách sử dụng cổng thông tin
                  GoPaperless và các trợ giúp cần thiết khác để bắt đầu sử dụng
                  cổng thông tin.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Danh bạ sổ địa chỉ được chia sẻ </strong>
                  <span className="color-1e90ff">
                    <strong>K |&nbsp;D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Làm cho các liên hệ hiển thị với tất cả người dùng trong nhóm
                  của bạn.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Danh mục tài liệu được chia sẻ </strong>
                  <span className="color-1e90ff">
                    <strong>K | D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Tạo danh mục tài liệu được chia sẻ cho phép đồng đội của bạn
                  truy cập tất cả các tài liệu trong danh mục.
                </p>
                <hr />
              </div>
              <div className="col-md-4">
                <h2 className="text-left font-weight-bold">Đ</h2>

                <p className="text-left">
                  <strong>Đăng nhập nhanh</strong>
                </p>
                <p className="text-left">
                  Đăng nhập vào cổng thông tin GoPaperless nhanh hơn vì trình
                  duyệt ghi nhớ thông tin đăng nhập cuối cùng của bạn, vì vậy
                  tất cả những gì bạn cần làm là xác nhận danh tính của mình
                  bằng cách nhập mã PIN của eID ưa thích mà không cần nhập thông
                  tin cá nhân mỗi lần.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Định dạng tài liệu đa dạng</strong>
                </p>
                <p className="text-left">
                  Ký tài liệu ở bất kỳ định dạng nào bạn cần — từ bộ chứa PDF và
                  ASiC-E đến các định dạng được sử dụng ở Baltics (BDoc, EDoc và
                  ADoc).
                </p>
                <hr />

                <p className="text-left">
                  <strong>Đăng ký với nhiều loại eID</strong>
                </p>
                <p className="text-left">
                  Ký tài liệu bằng giải pháp eID ưa thích của bạn, cho dù đó là
                  thẻ căn cước quốc gia, Mobile ID hay loại khác.&nbsp;
                  <a href="javascript:void(0)">
                    Xem tất cả các eID được hỗ trợ.
                  </a>
                </p>
                <hr />

                <p className="text-left">
                  <strong>Đa hành động</strong>
                </p>
                <p className="text-left">
                  Ký, xóa hoặc tải xuống tất cả các tài liệu đã chọn chỉ bằng
                  một cú nhấp chuột ở bất cứ đâu.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">G</h2>

                <p className="text-left">
                  <strong>Giao diện đa ngôn ngữ</strong>
                </p>
                <p className="text-left">
                  Sử dụng GoPaperless bằng tiếng Anh, tiếng Việt.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">H</h2>

                <p className="text-left">
                  <strong>Hỗ trợ VIP </strong>
                  <strong>
                    <span className="color-1e90ff">D</span>
                  </strong>
                </p>
                <p className="text-left">
                  Nhận tất cả sự hỗ trợ mà bạn có thể cần trong suốt thời gian
                  sử dụng GoPaperless.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">K</h2>
                <p className="text-left">
                  <strong>
                    Ký không cần tài khoản&nbsp;
                    <span className="color-1e90ff">C | K |&nbsp;D</span>
                  </strong>
                </p>
                <p className="text-left">
                  Cho phép khách hàng, đối tác của bạn hoặc các bên khác mà bạn
                  chia sẻ tài liệu ký tên hoặc xem chúng mà không cần đăng nhập
                  hoặc đăng ký vào cổng thông tin GoPaperless.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">N</h2>

                <p className="text-left">
                  <strong>Niêm phong</strong>
                </p>
                <p className="text-left">
                  Thay vì ký các tài liệu với tư cách là một người bình thường,
                  hãy đóng dấu chúng với tư cách là một người dùng hợp pháp bằng
                  cách sử dụng một con dấu điện tử.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Nhắc nhở</strong>
                </p>
                <p className="text-left">
                  Gửi lời nhắc bổ sung cho mọi người khi chữ ký hoặc phê duyệt
                  của họ đang chờ xử lý, chỉ bằng một lần bấm nút.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">P</h2>
                <p className="text-left">
                  <strong>
                    Phê duyệt <span className="color-1e90ff">K | D</span>
                  </strong>
                </p>
                <p className="text-left">
                  Thêm sự đồng ý bổ sung vào các tài liệu để đảm bảo chúng được
                  xem và xác nhận bởi người có trách nhiệm trước khi ký.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">Q</h2>

                <p className="text-left">
                  <strong>Quyền dựa trên danh mục tài liệu </strong>
                  <span className="color-1e90ff">
                    <strong>K | D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Quản lý quyền của người dùng để chỉnh sửa, chia sẻ hoặc xóa
                  tài liệu được phân vào danh mục.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Quản lý người dùng </strong>
                  <span className="color-1e90ff">
                    <strong>K | D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Dễ dàng quản lý tài khoản nhóm của bạn và quyền truy cập tài
                  liệu bằng cách sử dụng các biện pháp kiểm soát tập trung để
                  đảm bảo các tài liệu nhạy cảm luôn nằm trong tầm tay của người
                  dùng.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Quy trình làm việc </strong>
                  <span className="color-1e90ff">
                    <strong>K | D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Tạo một chuỗi hành động cho mọi bên ký kết để đảm bảo quy
                  trình ký tài liệu diễn ra suôn sẻ và theo thứ tự.
                </p>
                <hr />
              </div>
              <div className="col-md-4">
                <h2 className="text-left font-weight-bold">S</h2>

                <p className="text-left">
                  <strong>SLA cao cấp </strong>
                  <span className="color-1e90ff">
                    <strong>D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Dịch vụ hỗ trợ đảm bảo sẵn sàng 24/7.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Sổ địa chỉ và danh mục liên hệ</strong>
                </p>
                <p className="text-left">
                  Lưu danh bạ vào sổ địa chỉ để dễ dàng tìm thấy chúng vào lần
                  tới khi bạn cần chia sẻ tài liệu.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">T</h2>

                <p className="text-left">
                  <strong>Thời hạn</strong>
                </p>
                <p className="text-left">
                  Đặt thời hạn ký, niêm phong hoặc phê duyệt để đảm bảo các bên
                  khác thực hiện các hành động cần thiết đối với tài liệu của
                  bạn đúng hạn.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Thanh toán theo hóa đơn </strong>
                  <span className="color-1e90ff">
                    <strong>D</strong>
                  </span>
                </p>
                <p className="text-left">
                  Sử dụng các dịch vụ của GoPaperless và thanh toán bằng hóa đơn
                  nhận được vào cuối tháng.
                </p>
                <hr />

                <p className="text-left">
                  <strong>
                    Thanh toán tập trung{" "}
                    <span className="color-1e90ff">K | D</span>
                  </strong>
                </p>
                <p className="text-left">
                  Giảm thời gian dành cho việc thanh toán các hóa đơn riêng
                  biệt, thay vào đó hãy cấp cho mỗi thành viên trong nhóm tài
                  khoản GoPaperless của riêng họ và thanh toán mọi thứ bằng một
                  hóa đơn duy nhất.
                </p>
                <hr />

                <p className="text-left">
                  <strong>
                    Trải nghiệm người dùng có thương hiệu{" "}
                    <span className="color-1e90ff">K | D</span>
                  </strong>
                </p>
                <p className="text-left">
                  Cung cấp trải nghiệm ký tài liệu có thương hiệu cho khách hàng
                  và đối tác kinh doanh của bạn.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Thời gian hợp lệ&nbsp;</strong>
                </p>
                <p className="text-left">
                  Bảo vệ tài liệu của bạn khỏi bị giả mạo và ghi ngày tháng
                  ngược vì tất cả các giao dịch ký và niêm phong trong cổng
                  thông tin GoPaperless đều bao gồm dấu thời gian đủ điều kiện.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Tra cứu kiểm toán</strong>
                </p>
                <p className="text-left">
                  Xem tất cả các hành động được thực hiện bởi người dùng thông
                  qua danh sách chi tiết các sự kiện.
                </p>
                <hr />

                <p className="text-left">
                  <strong>Thông báo tự động</strong>
                </p>
                <p className="text-left">
                  Nhận thông báo khi cần chữ ký của bạn hoặc khi các bên khác đã
                  ký vào tài liệu.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">Ư</h2>

                <p className="text-left">
                  <strong>Ứng dụng di động</strong>
                </p>
                <p className="text-left">
                  Nhận tất cả các tính năng tuyệt vời của cổng thông tin khi
                  đang di chuyển cộng với thông báo tức thì về những gì đang
                  diễn ra với tài liệu của bạn ngay trên điện thoại di động của
                  bạn.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">V</h2>

                <p className="text-left">
                  <strong>Vai trò người dùng </strong>
                  <strong>
                    <span className="color-1e90ff">C | K |&nbsp;D</span>
                  </strong>
                </p>
                <p className="text-left">
                  Áp dụng các vai trò khác nhau cho người dùng: họ phải phê
                  duyệt hoặc ký một tài liệu hoặc chỉ có thể xem tài liệu đó.
                </p>
                <hr />

                <h2 className="text-left font-weight-bold">X</h2>

                <p className="text-left">
                  <strong>Xác thực chữ ký và con dấu</strong>
                </p>
                <p className="text-left">
                  Kiểm tra xem chữ ký hoặc con dấu của các bên khác có hợp lệ và
                  ràng buộc về mặt pháp lý hay không.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <Footer />
          <NavbarBottom />
        </motion.div>
      )}
    </>
  );
};

export default AllFeaturesContent;
